<template>
    <section class="navigation navigation-home">
        <section class="social-navigation">
            <div class="container-fluid">
                <div class="row py-0">
                    <div class="col-12">
                        <ul>
                            <li>
                                <a href="https://nl.pinterest.com/straalstudio/" target="_blank"><img src="https://straalstudio.be/assets/images/pinterest.svg" alt="Pinterest logo"></a>
                            </li>
                            <li>
                                <a href="https://www.facebook.com/straalstudio.kontich/" target="_blank"><img src="https://straalstudio.be/assets/images/facebook.svg" alt="Facebook logo"></a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/straalstudio/" target="_blank"><img src="https://straalstudio.be/assets/images/instagram.svg" alt="Instagram logo"></a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-6 col-sm-6 col-lg-4 col-logo">
                    <a href="https://straalstudio.be/home" class="navbar-brand">
                        <img :src="require('@/assets/straalstudio_logo.svg')" alt="Straalstudio logo">
                    </a>
                </div>
                <div class="col-6 col-sm-6 col-lg-8 my-auto">
                    <nav class="navbar navbar-expand-lg">
                        <button class="navbar-toggler navbar-toggler-right ml-auto" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                            <div id="toggle">
                                <span></span>
                                <span></span>
                                <span></span>
                            </div>
                        </button>
                        <div class="collapse navbar-collapse" id="collapsingNavbar">
                            <ul class="navbar-nav ml-auto">
                                <li><a href="https://straalstudio.be/home" class="nav-link ">Home</a></li>
                                <li><a href="https://straalstudio.be/realisaties" class="nav-link">Realisaties</a></li>
                                <li><a href="https://straalstudio.be/aanpak" class="nav-link ">Aanpak</a></li>
                                <li><a href="https://straalstudio.be/contact" class="nav-link mr-0 ">Contact</a></li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "Header"
    }
</script>

<style scoped lang="scss">
    @import '../../../node_modules/bootstrap/scss/bootstrap';

    // Body
    $body-bg: #f5f8fa;

    // Borders
    $laravel-border-color: darken($body-bg, 10%);
    $list-group-border: $laravel-border-color;
    $navbar-default-border: $laravel-border-color;
    $panel-default-border: $laravel-border-color;
    $panel-inner-border: $laravel-border-color;

    // Brands
    $brand-primary: #D1AD5A;
    $brand-info:    #8eb4cb;
    $brand-success: #2ab27b;
    $brand-warning: #cbb956;
    $brand-danger:  #bf5329;

    // Typography
    $icon-font-path: "~bootstrap-sass/assets/fonts/bootstrap/";
    $font-family-sans-serif: "Montserrat-light", sans-serif;
    $font-size-base: 14px;
    $line-height-base: 1.6;
    $text-color: #636b6f;

    $font-light:    300;
    $font-medium:   500;
    $font-semibold: 600;

    // Navbar
    $navbar-default-bg: #fff;

    // Buttons
    $btn-default-color: $text-color;

    // Inputs
    $input-border: lighten($text-color, 40%);
    $input-border-focus: lighten($brand-primary, 25%);
    $input-color-placeholder: lighten($text-color, 30%);

    // Panels
    $panel-default-heading-bg: #fff;

    // Standard Colors
    $black:     #000;
    $white:     #fff;
    $gray:      #707070;
    $lightgray: #F8F7F7;

    // Straalstudio Colors

    .social-navigation {
        background: $lightgray;
        text-align: center;
        padding: 15px 0;

        @media (min-width: 992px) {
            text-align: right;
        }

        ul {
            margin-bottom: 0;
            li {
                display: inline;
                margin-right: 20px;
                &:last-child {
                    margin-right: 25px;
                }
            }
        }
        img {
            height: 15px;
        }

    }
    .navigation {
        width: 100%;
        z-index: 9999;
        top: 0;
        left: 0;
        &.navigation-subpages {
            border-bottom: 1px solid $gray;
        }
        // Specific styling for extra small, small and large devices (< 991px)
        @include media-breakpoint-down(md){
            .navbar-brand img {
                width: 100px;
            }
            .navbar-collapse {
                position: fixed;
                width: 100%;
                right: 0;
                left: 0;
                top: 0;
                text-align: center;
                z-index: 999999;
            }
            .nav-link {
                color: $white;
                height: 25vh;
                text-transform: uppercase;
                background: $brand-primary;
                font-size: 1.6rem;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: 'Montserrat-semibold';
                font-weight: $font-semibold;
                transition: all .3s ease;
                &:hover {
                    color: $gray;
                }
            }
            button {
                cursor: pointer;
                &:focus {
                    outline: 0;
                }
            }
        }
        // Specific styling for large and extra large devices (> 991px)
        @include media-breakpoint-up(lg){
            .row {
                width: 95%;
                padding-top: 15px;
                padding-bottom: 15px;
                margin: auto;
            }
            .navbar-brand img {
                width: 200px;
            }
            .nav-link {
                color: $white;
                font-family: 'Montserrat-semibold';
                font-weight: $font-semibold;
                letter-spacing: .05em;
                font-size: 1em;
                text-transform: uppercase;
                transition: all .3s ease;
                margin-right: 30px;
                &.nav-link-subpages {
                    color: $gray;
                }
                &:hover, &.active {
                    color: $brand-primary;
                }
            }
        }
        @media (min-width: 1350px){
            .row {
                width: 90%;
            }
        }
        @media (min-width: 1600px){
            .row {
                max-width: 1300px;
            }
        }
    }

    // Toggle animation
    #toggle {
        width: 25px;
        height: 18px;
        position: relative;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .15s ease-in-out;
        -moz-transition: .15s ease-in-out;
        -o-transition: .15s ease-in-out;
        transition: .15s ease-in-out;
    }

    #toggle span {
        display: block;
        position: absolute;
        height: 3px;
        width: 100%;
        background: $brand-primary;
        opacity: 1;
        left: 0;
        -webkit-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
        -webkit-transition: .25s ease-in-out;
        -moz-transition: .25s ease-in-out;
        -o-transition: .25s ease-in-out;
        transition: .25s ease-in-out;
    }

    #toggle span:nth-child(1) {
        top: 0px;
    }

    #toggle span:nth-child(2) {
        top: 7px;
    }

    #toggle span:nth-child(3) {
        top: 14px;
    }

    #toggle.open {
        position: fixed;
        right: 20px;
        top: 20px;
    }

    #toggle.open span:nth-child(1) {
        top: 7px;
        -webkit-transform: rotate(135deg);
        -moz-transform: rotate(135deg);
        -o-transform: rotate(135deg);
        transform: rotate(135deg);
        background: $lightgray;
    }

    #toggle.open span:nth-child(2) {
        opacity: 0;
        left: -30px;
        background: $lightgray;
    }

    #toggle.open span:nth-child(3) {
        top: 7px;
        -webkit-transform: rotate(-135deg);
        -moz-transform: rotate(-135deg);
        -o-transform: rotate(-135deg);
        transform: rotate(-135deg);
        background: $lightgray;
    }
    .navbar-toggler {
        z-index: 9999;
        color: red;
    }


     .navigation .nav-link {
        color: $gray;
        &:hover, &.active {
            color: $white;
        }
        @include media-breakpoint-up(lg){
            &:hover, &.active {
                color: $brand-primary;
            }
        }
    }

    .navigation {
        background: white;
        border-bottom: 1px solid #707070;
    }

    @media (min-width: 992px) {
        .navigation .row {
            width: 95%;
            padding-top: 15px;
            padding-bottom: 15px;
            margin: auto;
        }
    }
</style>